import { render, staticRenderFns } from "./AdminAI.vue?vue&type=template&id=9a99aeba&scoped=true"
import script from "./AdminAI.vue?vue&type=script&lang=js"
export * from "./AdminAI.vue?vue&type=script&lang=js"
import style0 from "./AdminAI.vue?vue&type=style&index=0&id=9a99aeba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a99aeba",
  null
  
)

export default component.exports